import ShButton from '@/components/Helpers/ShButton';
import HintAndExplanation from '@/components/Common/HintAndExplanation';

// @vue/component
export default {
  name: 'NumberVerificationForm',

  components: {
    ShButton,
    HintAndExplanation,
  },

  props: {
    verifiedNumber: {
      type: Object,
      required: true,
    },
    isSkipDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      codeResendInterval: null,
      codeHasBeenSended: false,
      codeResendAdditionalTextForButton: null,
      code: null,
      verificationType: 'sms',
      hintMessages: {
        sms: `Na wskazany numer telefonu zostanie wysłany SMS z 6-cyfrowym kodem, który należy wpisać poniżej. 
        Nową wiadomość z kodem weryfikacyjnym możesz wysłać po upływie 60 sekund.`,
        phone: `System zadzwoni na wskazany numer telefonu i podyktuje 6-cyfrowy numer, który należy wpisać poniżej.
        Nową wiadomość z kodem weryfikacyjnym możesz wysłać po upływie 60 sekund.`,
      },
    };
  },

  computed: {
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'numbers/sendVerificationCode',
        'numbers/confirmVerificationCode',
      ]);
    },
  },

  mounted() {
    this.code = null;
  },

  methods: {
    __handleResendCodeAfter60minutes() {
      clearTimeout(this.codeResendInterval);
      this.codeResendInterval = setTimeout(() => {
        this.codeHasBeenSended = false;
        this.codeResendAdditionalTextForButton = 'ponownie';
      }, 60000);
    },
    async handleSendVerificationCode() {
      const params = {
        type: this.verificationType,
        id: this.verifiedNumber.id,
      };
      await this.$store.dispatch('numbers/sendVerificationCode', params);
      this.codeHasBeenSended = true;
      this.$notify.success({
        title: 'Kod weryfikacyjny',
        message: `Wysłano kod weryfikacyjny na numer: ${this.verifiedNumber.number}`,
        customClass: 'callmeweb-notification',
      });

      this.__handleResendCodeAfter60minutes();
    },
    async handleConfirmVerificationCode() {
      const params = {
        number_id: this.verifiedNumber.id,
        code: this.code,
      };
      const isVerified = await this.$store.dispatch('numbers/confirmVerificationCode', params);

      if (isVerified) {
        this.$notify.success({
          title: 'Weryfikacja',
          message: `Numer: ${this.verifiedNumber.number} został poprawnie zweryfikowany. Możesz utworzyć nowego Konsultanta`,
          customClass: 'callmeweb-notification',
        });
        this.code = null;
        if (this.verifiedNumber.isConfigModal) {
          this.$emit('handleAddNewAgent', this.verifiedNumber);
        } else {
          this.$emit('closeModal');
          this.$EventBus.$emit('NumbersListItem/CREATE_NEW_AGENT', this.verifiedNumber);
        }
        this.$store.dispatch('numbers/getList');
      }
    },
    handleCancel() {
      this.codeHasBeenSended = false;
      this.code = null;
      this.$emit('closeModal');
    },
  },
};
